import { fetcher } from '../../../lib/api-fetcher';
import { useQuery } from '@tanstack/react-query';


export interface EstimateInput {
  decayModel?: 'LINEAR' | 'SIGMOID' | 'UNIFORM';
  assumedStartDiscountPct?: number;
  assumedEndDiscountPct?: number;
  gstRate?: number;
}

export interface CycleProjection {
  cycleNumber: number;
  status: 'ACTUAL' | 'PROJECTED';
  scheduledDate: string;
  subscriptionDue: number;
  dividendPool: number;
  perSubscriberDividend: number;
  winningDiscount: number;
  foremanCommission: number;
  gstOnCommission: number;
  netPrizePayout: number;
  winnerSubscriptionId: string | null;
}

export interface SubscriberYieldProfile {
  winCycle: number;
  totalPaidIn: number;
  netPrizeReceived: number;
  netBenefit: number;
  annualizedYieldPct: number;
}

export interface HybridEstimateResult {
  schemeId: string;
  displayName: string;
  schemeNumber: string;
  chitValue: number;
  subscriberCount: number;
  durationCycles: number;
  commissionRate: number;
  gstApplicable: boolean;
  tdsApplicable: boolean;
  totalActualDividendsPaid: number;
  totalProjectedDividends: number;
  totalProjectedCommissions: number;
  totalProjectedGst: number;
  cycles: CycleProjection[];
  yieldProfiles: SubscriberYieldProfile[];
}

export const estimateKeys = {
  all: ['estimate'] as const,
  scheme: (id: string, params: EstimateInput) => [...estimateKeys.all, id, params] as const,
};

export function useSchemeEstimate(schemeId: string, params: EstimateInput, enabled = false) {
  return useQuery({
    queryKey: estimateKeys.scheme(schemeId, params),
    queryFn: async () => {
      return fetcher.post<HybridEstimateResult>(
        `/staff/v1/chit-groups/${schemeId}/estimate`,
        params
      );
    },
    enabled: enabled && !!schemeId,
    staleTime: 60_000,
  });
}
